module.exports = __webpack_public_path__ + "share_black.544f5f30.png";